<template>
    <div>
        <template v-if="getActiveSiteGrades && getActiveSiteSectionOptions">
            <!-- Collapsable Instructions -->
            <div class="mb-4">
                <b-button
                    v-b-toggle="'collapse-instructions-grades'"
                    class="m-1"
                    variant="warning"
                >
                    <b-icon-eye /> Ver/Ocultar Instrucciones
                </b-button>

                <b-collapse id="collapse-instructions-grades">
                    <b-card>
                        <p>
                            Para editar las calificaciones, haga click en una celda y cambie su valor, los bordes de la celda
                            editada se volverán verdes para indicar que la calificación <strong>no ha sido guardada</strong>.
                            Para guardar la nueva calificación presione ENTER con la celda aún seleccionada.
                            Las celdas con bordes rojos indican un valor inválido.<br /><br />
                            Utilice <strong>punto</strong> en vez de coma para indicar valores decimales.
                        </p>
                    </b-card>
                </b-collapse>
            </div>

            <b-tabs
                active-nav-item-class="bg-primary text-white"
            >
                <b-tab
                    v-for="sectionObj in getActiveSiteSectionOptions"
                    :key="`section-grades-${sectionObj.value}`"
                    :title="sectionObj.text"
                    :active="sectionObj.text === selectedSection"
                    @click="setGradesSection(sectionObj.text)"
                />
            </b-tabs>

            <b-table
                hover
                responsive
                striped
                bordered
                sticky-header="500px"
                no-border-collapse
                :items="gradeRows"
                :fields="gradeFields"
                :sort-by="'name'"
                :sort-desc="false"
            >
                <template v-slot:cell()="data">
                    <span
                        v-if="data.field.key === 'name' || data.field.key === 'identity_card'"
                        class="align-middle"
                    >
                        {{ data.value }}
                    </span>
                    <span v-else>
                        <!-- Add spinner element when calification is being updated -->
                        <div v-if="data.item[data.field.key].updating" class="text-center">
                            <b-spinner label="Actualizando calificacion..." small variant="primary" />
                        </div>
                        <b-form-input
                            v-else
                            v-model.number="data.item[data.field.key].grade_value"
                            :class="{
                                'text-center': true,
                                'is-invalid': isGradeInvalid(data.item[data.field.key]),
                                'is-valid': isGradeValid(data.item[data.field.key])
                            }"
                            type="number"
                            min="0"
                            max="20"
                            step="any"
                            @keyup.prevent.enter="onEnterKeyPressed(data.item[data.field.key])"
                            @blur="onInputBlur(data.item[data.field.key])"
                        />
                    </span>
                </template>
            </b-table>
        </template>
        <h5 v-else class="pt-4">
            No existe ninguna evaluación o estudiantes para este sitio web.
        </h5>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'UpdateStudentGrades',
    data () {
        return {
            selectedSection: ''
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteEvaluations',
            'getActiveSiteGrades',
            'getActiveSiteSectionOptions'
        ]),
        gradeFields () {
            var fields = [
                { key: 'identity_card', stickyColumn: true, label: 'Cédula', thClass: 'text-center' },
                { key: 'name', stickyColumn: true, label: 'Estudiante', thClass: 'w-250p text-center', sortable: true }
            ]
            this.getActiveSiteEvaluations.map(evaluation => {
                if (evaluation.id !== -1) { // Avoid pushing the evaluations total row
                    fields.push({ key: `[${evaluation.id}]${evaluation.name}`, label: evaluation.name, thClass: 'w-180p text-center' })
                }
            })

            return fields
        },
        gradeRows () {
            return this.getActiveSiteGrades[this.selectedSection]
        }
    },
    methods: {
        ...mapActions([
            'updateSingleStudentGrade'
        ]),
        isValueInRange (val) {
            return val >= 0 && val <= 20
        },
        isGradeInvalid (grade) {
            return grade.grade_value === '' || !this.isValueInRange(grade.grade_value)
        },
        isGradeValid (grade) {
            return !this.isGradeInvalid(grade) && grade.grade_value !== grade.old_grade
        },
        setGradesSection (sectionName) {
            this.selectedSection = sectionName
        },
        async onEnterKeyPressed (grade) {
            grade.updating = true
            try {
                if (this.isGradeValid(grade)) {
                    const payload = {
                        courseSiteId: this.activeSite.id,
                        evaluationId: grade.evaluation_id,
                        gradeId: grade.grade_id,
                        gradeValue: grade.grade_value
                    }
                    await this.updateSingleStudentGrade(payload)
                    this.$root.infoToast(`Calificación actualizada de ${grade.old_grade} a ${payload.gradeValue}.`)
                    grade.old_grade = grade.grade_value
                } else if (this.isGradeInvalid(grade)) {
                    this.$root.warningToast(`El valor debe estar entre 0 y 20`, 'Calificación Inválida')
                }
            } catch (err) {
                return this.$root.unknownErrorToast()
            }
            grade.updating = false
        },
        onInputBlur (grade) {
            if (grade.grade_value === '' || this.isGradeInvalid(grade)) {
                grade.grade_value = grade.old_grade
            }
        }
    },
    mounted () {
        if (this.getActiveSiteSectionOptions) {
            this.selectedSection = this.getActiveSiteSectionOptions[0].text
        }
    }
}
</script>
